// extracted by mini-css-extract-plugin
export default {"underLine":"text_underLine__0cZMH","sh1":"text_sh1__NF+Ti","sh2":"text_sh2__4ojir","sh3":"text_sh3__knuE2"};